"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_text_info_n_1 = __importDefault(require("@gerenciatd/next.components.text-info-n"));
const constants_1 = require("../../constants");
const PillSlider_1 = __importDefault(require("./PillSlider"));
const Territory = ({ isPriority, title, backLink, pillsArray, location, segment, }) => {
    const cssSegment = ` ${segment}`;
    const cssPriority = segment !== constants_1.EMPRESAS && isPriority ? ` ${constants_1.PRIORITY}` : '';
    let spaceBetweenCheuronAndTitle = 'regular';
    if (title && title.length >= 21) {
        spaceBetweenCheuronAndTitle = 'short';
    }
    return (react_1.default.createElement("div", { className: `Territory${cssPriority}${cssSegment}` },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "TerritoryContainer" },
                react_1.default.createElement("div", { className: "BackLinkAndTitle" },
                    react_1.default.createElement("div", { className: "BackLinkGap" }, backLink && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(next_components_icon_n_1.default, { id: "CheuronLeft", size: 20, className: `backLink${cssPriority}${cssSegment}`, color: "grey4" }),
                        react_1.default.createElement(next_components_custom_link_1.default, { href: backLink, className: "clbackLink", taggingInfo: {
                                componentname: 'header',
                                componentVariation: 'all',
                                componentProduct: '',
                                componentContent: `back-to-${backLink}`,
                            } })))),
                    react_1.default.createElement("div", { className: `GapBetweenCheuronAndTitle ${spaceBetweenCheuronAndTitle}` }),
                    react_1.default.createElement("div", { className: "TitleSection" },
                        react_1.default.createElement(next_components_text_info_n_1.default, { color: "green-dark", className: `pageTitle${cssSegment}`, text: title, size: "title02", segment: segment, fontType: "font-light", display: "block", align: "left" }))),
                react_1.default.createElement("div", { className: "PillsContainer desktop" }, pillsArray && Array.isArray(pillsArray) && (react_1.default.createElement(PillSlider_1.default, { location: location, pillsArray: pillsArray, isPriority: isPriority, segment: segment }))))),
        react_1.default.createElement("div", { className: "PillsContainer mobile" }, pillsArray && Array.isArray(pillsArray) && (react_1.default.createElement(PillSlider_1.default, { mobile: true, location: location, pillsArray: pillsArray, isPriority: isPriority, segment: segment })))));
};
exports.default = Territory;
//# sourceMappingURL=index.js.map